module.exports = __webpack_public_path__ + "img/smc.712e98e1.jpg";